<ng-container *ngIf="categories_obj.GENERAL === category; else isCustomCategory">
    <app-navbar class="home"></app-navbar>
    <div class="container">
        <div class="faq-wrapper">
            <div class="text-center mb-5">
                <h1>Questions?</h1>
                <p class="xl">We've got answers.</p>
            </div>
            <ng-container *ngTemplateOutlet="faqTemplate"></ng-container>
        </div>
    </div>
    <app-footer></app-footer>
</ng-container>

<ng-template #isCustomCategory>
    <div class="faq-wrapper" *ngIf="faqs.length">
        <div class="text-center mb-5">
            <h1>Frequently Asked Questions</h1>
        </div>
        <ng-container *ngTemplateOutlet="faqTemplate"></ng-container>
    </div>
</ng-template>

<ng-template #faqTemplate>
    <div class="row justify-content-center">
        <div class="col-lg-8">
            <div class="accordion accordion-wrapper v2">
                <ng-container *ngFor="let faq of faqs">
                    <div class="accordion-item">
                        <h2 class="accordion-header" [id]="'heading' + faq.id">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                [attr.data-bs-target]="'#collapse' + faq.id" aria-expanded="true"
                                [attr.aria-controls]="'collapse' + faq.id">
                                {{faq.question}}
                            </button>
                        </h2>
                        <div [id]="'collapse' + faq.id" class="accordion-collapse collapse"
                            [attr.aria-labelledby]="'heading' + faq.id" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <p class="lg" [innerHtml]="faq.answer"></p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>